/** Съвпада с `ClientsSqlSupport::CLIENT_PROFILE_PREFIX` в backend. */
export const CLIENT_PROFILE_PREFIX = "Клиентски номер-";

const LEGACY_PROFILE_PREFIX = "PRT-";

const INVALID_PROFILE_TOKENS = new Set([
    "клиенти",
    "clients",
    "client",
    "profile",
    "undefined",
    "null",
]);

export function extractPartnerIdFromProfileId(value: string): number | null {
    const normalized = normalizeClientProfileId(value);

    if (!normalized) {
        return null;
    }

    const suffix = normalized.slice(CLIENT_PROFILE_PREFIX.length);
    const partnerId = Number.parseInt(suffix, 10);

    return Number.isFinite(partnerId) && partnerId > 0 ? partnerId : null;
}

export function isValidClientProfileId(value: string): boolean {
    return normalizeClientProfileId(value) !== null;
}

export function normalizeClientProfileId(value: string): string | null {
    const trimmed = value.trim();

    if (trimmed === "") {
        return null;
    }

    if (INVALID_PROFILE_TOKENS.has(trimmed.toLowerCase())) {
        return null;
    }

    if (trimmed.startsWith(CLIENT_PROFILE_PREFIX)) {
        const partnerId = trimmed.slice(CLIENT_PROFILE_PREFIX.length);

        return /^\d+$/.test(partnerId) ? trimmed : null;
    }

    if (trimmed.startsWith(LEGACY_PROFILE_PREFIX)) {
        const partnerId = trimmed.slice(LEGACY_PROFILE_PREFIX.length);

        return /^\d+$/.test(partnerId) ? `${CLIENT_PROFILE_PREFIX}${partnerId}` : null;
    }

    if (/^\d+$/.test(trimmed)) {
        return `${CLIENT_PROFILE_PREFIX}${trimmed}`;
    }

    const suffixMatch = trimmed.match(/(\d+)$/);

    if (!suffixMatch) {
        return null;
    }

    const partnerId = suffixMatch[1];

    if (trimmed.includes(CLIENT_PROFILE_PREFIX) || trimmed.includes(LEGACY_PROFILE_PREFIX)) {
        return `${CLIENT_PROFILE_PREFIX}${partnerId}`;
    }

    return null;
}

export function profileIdFromPartnerId(partnerId: number): string | null {
    if (!Number.isFinite(partnerId) || partnerId <= 0) {
        return null;
    }

    return `${CLIENT_PROFILE_PREFIX}${Math.trunc(partnerId)}`;
}

export function profileIdsMatch(left: string, right: string): boolean {
    const a = normalizeClientProfileId(left);
    const b = normalizeClientProfileId(right);

    return a !== null && b !== null && a === b;
}

export function findProfileInDataset<T extends { profileId: string }>(
    profiles: T[] | undefined,
    profileId: string,
): T | null {
    if (!profiles?.length) {
        return null;
    }

    const exact = profiles.find((row) => row.profileId === profileId);
    if (exact) {
        return exact;
    }

    return profiles.find((row) => profileIdsMatch(row.profileId, profileId)) ?? null;
}
